import { UserPlanType } from '../UserPlan';
import { IMarketSegmentSelection } from './IMarketSegmentSelection';

export enum UserPlanFeature {
  XlsExport = 'xlsExport',
  NewIssueStats = 'newIssueStats',
  CommentaryAndDealFlow = 'commentaryAndDealFlow',
}

export interface IUserPlanPreferences {
  productIds?: string[],
  regionIds?: string[],
  marketIds?: string[],
  marketSegments?: IMarketSegmentSelection,
}

interface IUserPlanRole {
  id: string,
  name: string,
}

export interface IUserPlanResponse {
  plan: UserPlanType,
  features: UserPlanFeature[],
  regions: string[],
  products: string[],
  hasServerError?: boolean,
  preferences: IUserPlanPreferences | null,
  role: IUserPlanRole | null,
}
